import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import type { ItemType, MenuItemType } from "antd/es/menu/interface";
import { Link, useLocation } from "react-router";
import type { TUserRoles } from "../../app/app.constants";

import useAuth from "../../hooks/useAuth";
import { APP_ROUTES } from "../../routes/routes";
import type { AppRoute } from "../../types/global.types";
import { cn, filterRoutesByRole, findMenuKeys } from "../../utils/global.utils";
import { useEffect, useState } from "react";
import LeftSideGroupArrowIcon from "../_icons/LeftSideGroupArrowIcon";
import RightSideGroupArrowIcon from "../_icons/RightSideGroupArrowIcon";

const Sidebar = () => {
  const { role } = useAuth();
  const location = useLocation();
  const filteredMenu = filterRoutesByRole(APP_ROUTES, role as TUserRoles, true);

  const { selectedKey, openKeys } = findMenuKeys(
    filteredMenu,
    location.pathname
  );

  // ✅ Default collapsed, but restore from localStorage if exists
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    const saved = localStorage.getItem("collapsed");
    return saved ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem("collapsed", JSON.stringify(collapsed));
  }, [collapsed]);

  const buildMenu = (routes: AppRoute[]): ItemType<MenuItemType>[] =>
    routes.map((route) => ({
      key: route.path,
      icon: route.icon ? (
        collapsed && !route.children?.length ? (
          <Link to={route.path}>
            <span className="anticon anticon-home ant-menu-item-icon">
              <route.icon />
            </span>
          </Link>
        ) : (
          <span className="anticon anticon-home ant-menu-item-icon">
            <route.icon />
          </span>
        )
      ) : undefined,
      label: route.children?.length ? (
        route.label
      ) : (
        <Link to={route.path}>{route.label}</Link>
      ),
      children: route.children ? buildMenu(route.children) : undefined,
    }));

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      theme="light"
      width={312}
      className="shadow-md custom-sidebar"
    >
      {/* Sidebar Menus */}
      <button
        onClick={() => setCollapsed((prev: boolean) => !prev)}
        className="
    absolute 
    top-0
    right-0
    z-50 
    flex 
    items-center 
    justify-center
  "
      >
        {collapsed === true ? (
          <LeftSideGroupArrowIcon className="text-lg" />
        ) : (
          <RightSideGroupArrowIcon className="text-lg" />
        )}
      </button>

      <div
        className={cn(
          !collapsed && "px-2",
          "max-h-[calc(100vh_-_105px)] overflow-y-auto mt-4"
        )}
      >
        <Menu
          theme="light"
          mode="inline"
          className="!border-none"
          selectedKeys={[selectedKey]}
          defaultOpenKeys={openKeys}
          items={buildMenu(filteredMenu)}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
